<template>
  <div class="report-user-content">
      <div class="row">
        <!-- Leads -->
        <div class="col-md-12">
          <b-card no-body>
            <!-- <b-card-header>
              <b-card-sub-title class="mb-25">
                {{ `Total de Leads: ${leads}` }}
              </b-card-sub-title>
            </b-card-header> -->
            <!-- <b-card-header>
              <b-card-sub-title class="mb-25">
                {{ `Total de Leads por período: ${leadsByPeriod.totalPeriod || 0}` }}
              </b-card-sub-title>
            </b-card-header> -->
            <b-card-header class="statistics-filter-header">
              Filtro
            </b-card-header>
            <b-card-body class="report-leads-body">
              <b-overlay class="custom-overlay" :show="displayOverlayLeadsByPeriod" rounded="sm">
                <div class="d-flex col-md-6">
                  <!-- <feather-icon icon="CalendarIcon" size="16" /> -->
                  <flat-pickr
                    v-model="rangePickerReportLeadsByPeriod"
                    class="form-control-sm form-date"
                    :placeholder="$t('MANAGE_NEWS_FILTER.Period')"
                    :config="{
                      enableTime: false,
                      dateFormat: 'Y-m-d',
                      altInput: true,
                      altFormat: 'd/m/Y',
                      allowInput: true,
                      mode: 'range',
                    }"
                  />
                </div>
                <div class="report-buttons">
                  <b-button
                    class="search-button"
                    variant="primary"
                    size="sm"
                    @click="fetchLeadsByPeriod()"
                  >
                    <feather-icon icon="SearchIcon" class="export-button-icon"/>
                    {{ $t("MANAGE_NEWS_FILTER.Search") }}
                  </b-button>
                  <b-button
                    variant="primary"
                    size="sm"
                    @click="reportData()"
                  >
                    <feather-icon icon="FileTextIcon" class="export-button-icon"/>
                    Exportar
                  </b-button>
                  <b-button 
                    variant="primary"
                    size="sm" 
                    @click="onClear"
                  >
                    <feather-icon icon="TrashIcon" class="export-button-icon"/>
                    {{ $t('MANAGE_NEWS_FILTER.Clear') }}
                  </b-button>
                </div>

                <div>
                  <!-- <b-card 
                    v-for="(item, index) in leadsByPeriod.data"
                    :key="index"
                    :header="item.date"
                  >
                    <b-list-group v-if="item.emails && item.emails.length">
                      <b-list-group-item 
                        v-for="(email, emailIndex) in item.emails"
                        :key="emailIndex"
                        href="#"
                      >
                        {{ email }}
                      </b-list-group-item>
                    </b-list-group>
                    <p v-else>Nenhum lead para este dia.</p>
                  </b-card> -->
                  <custom-g-table
                    v-if="displayTable"
                    ref="custom-table"
                    :displayLoading="tableLoading"
                    :fields="fields"
                    :items="leadsByPeriod"
                    :totalRows="totalRows"
                    :limit="limit"
                    :tableMaxHeight="tableMaxHeight"
                    @changePage="onChangePage"
                  />
                </div>
              </b-overlay>
            </b-card-body>
          </b-card>
        </div>
      </div>
  </div>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardHeader,
  // BCardSubTitle,
  BButton,
  BOverlay,
  // BListGroup,
  // BListGroupItem
} from "bootstrap-vue";
import flatPickr from "vue-flatpickr-component";
import { ref, watch } from "@vue/composition-api";
// import convertDatetimeHelper from '@/helpers/convert-datetime-helper';
import sendLeadService from "@/providers/sendLeadService";
import AppConstants from "@/appConstants";
import CustomGTable from "@/views/custom/table/CustomGTable.vue";
import { useWindowSize } from "@vueuse/core";
import messagesNotifyHelper from '@/helpers/messages-notify-helper';

export default {
  components: {
    BCardHeader,
    BCard,
    BCardBody,
    // BCardSubTitle,
    flatPickr,
    BButton,
    BOverlay,
    // BListGroup,
    // BListGroupItem
    CustomGTable
  },
  setup() {
    const displayOverlayLeadsByPeriod = ref(false);
    // const rangePickerReportLeadsByPeriod = ref(convertDatetimeHelper.getDateRangeFilterFormat());
    const rangePickerReportLeadsByPeriod = ref("");
    const leads = ref(0);
    const page = ref(1);
    const leadsByPeriod = ref([]);
    const perfectScrollbarSettings = {
      maxScrollbarLength: 60,
      wheelSpeed: 0.3,
      swipeEasing: true,
    };
    const displayTable= ref(false);
    const totalRows = ref(0);
    const limit = ref(AppConstants.PAGINATOR_DEFAULT_LIMIT);
    // const limit = ref(15);
    const tableLoading = ref(false);
    const fields = [
      {
        field: "dt_create",
        label: "Criação",
        type: "custom_date",
        sortable: false,
        // filterOptions: {
        //   filterValue: '',
        //   enabled: true,
        //   placeholder: "Pesquisar por data",
        //   trigger: "enter",
        // },
      },
      // {
      //   field: "dt_sent",
      //   label: "Data de Envio",
      //   type: "custom_date",
      //   sortable: false,
      //   // filterOptions: {
      //   //   filterValue: '',
      //   //   enabled: true,
      //   //   placeholder: "Pesquisar por data envio",
      //   //   trigger: "enter",
      //   // },
      // },
      // {
      //   field: "dt_update",
      //   label: "Data de Alteração",
      //   type: "custom_date",
      //   sortable: false,
      //   // filterOptions: {
      //   //   filterValue: '',
      //   //   enabled: true,
      //   //   placeholder: "Pesquisar por data",
      //   //   trigger: "enter",
      //   // },
      // },
      // { 
      //   field: "sent", 
      //   label: "Enviado", 
      //   type: "boolean", 
      //   sortable: false, 
      //   // filterOptions: { 
      //   //   filterValue: '', 
      //   //   enabled: true, 
      //   //   placeholder: 'Pesquisar por Enviado', 
      //   //   filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] 
      //   // } 
      // },
      {
        field: "body.nome",
        label: "Nome",
        sortable: false,
        // filterOptions: {
        //   filterValue: '',
        //   enabled: true,
        //   placeholder: "Pesquisar por Email",
        //   trigger: "enter",
        // },
      },
      {
        field: "email",
        label: "Email",
        sortable: false,
        // filterOptions: {
        //   filterValue: '',
        //   enabled: true,
        //   placeholder: "Pesquisar por Email",
        //   trigger: "enter",
        // },
      },
      {
        field: "body.ddd",
        label: "DDD",
        sortable: false,
        // filterOptions: {
        //   filterValue: '',
        //   enabled: true,
        //   placeholder: "Pesquisar por Email",
        //   trigger: "enter",
        // },
      },
      {
        field: "body.celular",
        label: "Telefone",
        sortable: false,
        // filterOptions: {
        //   filterValue: '',
        //   enabled: true,
        //   placeholder: "Pesquisar por Email",
        //   trigger: "enter",
        // },
      },
      // {
      //   field: "errorOnSent",
      //   label: "Erro ao Enviar",
      //   type: "boolean",
      //   sortable: false,
      //   // filterOptions: { 
      //   //   filterValue: '', 
      //   //   enabled: true, 
      //   //   placeholder: 'Pesquisar por Erro ao Enviar', 
      //   //   filterDropdownItems: [{value: true, text: 'Sim'}, {value: false, text: 'Não'}] 
      //   // },
      // },
      // {
      //   field: "errorMessage",
      //   label: "Mensagem de erro",
      //   sortable: false,
      //   // filterOptions: {
      //   //   filterValue: '',
      //   //   enabled: true,
      //   //   placeholder: "Pesquisar por Mensagem de erro",
      //   //   trigger: "enter",
      //   // },
      // },
      // {
      //   field: "body",
      //   label: "Body",
      //   sortable: false,
      // },
    ];

    const onChangePage = (newPage) => {
      page.value = newPage;
      fetchLeadsByPeriod();
    };

    // const fetchLeads = () => {
    //   const params = new URLSearchParams();
    //   sendLeadService.getTotalLeads(params)
    //     .then(res => {
    //       leads.value = res.total;
    //     })
    //     .catch(err => console.error('Error fetching total leads:', err));
    // };

    const fetchLeadsByPeriod = () => {
      tableLoading.value = true;
      const params = new URLSearchParams();
      params.append("page", page.value);
      params.append("limit", limit.value);

      if (rangePickerReportLeadsByPeriod.value) {
        params.append("dt_range", rangePickerReportLeadsByPeriod.value);
      }
      sendLeadService.getall(params)
        .then(res => {
          displayTable.value = true;
          leadsByPeriod.value = res.data;
          totalRows.value = res.totalRows;
        })
        .catch(err => console.error('Error fetching leads by period:', err))
    };

    const reportData = () => {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('limit', limit);
      
      if (rangePickerReportLeadsByPeriod.value) {
        params.append("dt_range", rangePickerReportLeadsByPeriod.value);
      }
      if (!rangePickerReportLeadsByPeriod.value || rangePickerReportLeadsByPeriod.value <= 0) {
        messagesNotifyHelper.errorNotify(
          "Erro",
          "Filtro Período obrigatório"
        );
        return;
      }
      params.append("download", true);
      sendLeadService
        .report(params)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", 'relatorio-de-gratuitos.xlsx');
          link.setAttribute("id", "link-download");

          document.body.appendChild(link);
          link.click();

          document.getElementById("link-download").remove();
        })
        .catch((error) => {
          console.log(error);
          messagesNotifyHelper.errorNotify("Erro", "Sem dados para exportar, verifique sua pesquisa e tente novamente");
          // if (error.message) {
          //   messagesNotifyHelper.errorNotify("Erro", error.message);
          // } else {
          // }
        });
    };

    const onClear= () => {
      rangePickerReportLeadsByPeriod.value = "";
    };

    const tableMaxHeight = ref(AppConstants.CUSTOM_TABLE_DEFAULT_HEIGHT);
    const { height: windowheight } = useWindowSize();
    watch(windowheight, (val) => {
      if (val < 900) {
        tableMaxHeight.value = '200px';
      } else {
        tableMaxHeight.value = AppConstants.CUSTOM_TABLE_DEFAULT_HEIGHT;
      }
    },  { immediate: true });


    // fetchLeads();

    return {
      tableLoading,
      limit,
      totalRows,
      fields,
      displayTable,
      leads,
      leadsByPeriod,
      displayOverlayLeadsByPeriod,
      // fetchLeads,
      fetchLeadsByPeriod,
      perfectScrollbarSettings,
      rangePickerReportLeadsByPeriod,
      reportData,
      onChangePage,
      onClear,
      tableMaxHeight
    };
  },
};
</script>

<style>
.report-leads-body {
  display: flex;
  flex-direction: column;
}
.report-leads-body .align-items-center {
  margin-bottom: 20px;
  width: auto;
}

.report-leads-body .form-date {
  width: 400px;
  margin-right: 20px;
}

.search-button {
  margin-right: 10px;
}

.export-button-icon {
  height: 13px;
  width: 13px;
}

.report-buttons button {
  margin-right: 10px;
}

.report-buttons {
  padding: .5rem;
}

</style>